import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../../contexts/ThemeContext';
import type { WidgetShellProps } from './types';

const WidgetShell: React.FC<WidgetShellProps> = ({
  title,
  embedded,
  viewAllPath,
  isLoading,
  empty,
  emptyMessage = 'No data',
  headerExtra,
  children,
  skeleton,
}) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const cardClass = embedded
    ? 'min-w-0 flex-1 flex flex-col min-h-0'
    : `${colors.surface} rounded-xl shadow-sm p-5 ${colors.border} border`;

  return (
    <div className={cardClass}>
      <div className="flex items-center justify-between mb-4 flex-shrink-0 gap-2">
        <h2 className={`text-base font-semibold ${colors.text}`}>{title}</h2>
        <div className="flex items-center gap-2 shrink-0">
          {headerExtra}
          {viewAllPath ? (
            <button
              type="button"
              onClick={() => navigate(viewAllPath)}
              className={`text-sm font-medium whitespace-nowrap transition-colors ${colors.primaryFg} hover:opacity-80`}
            >
              View All
            </button>
          ) : null}
        </div>
      </div>
      {isLoading ? (
        skeleton ?? <div className={`h-24 rounded-lg ${colors.surfaceHover} animate-pulse`} />
      ) : empty ? (
        <div className={`text-center py-8 ${colors.textMuted}`}>
          <p className="text-sm">{emptyMessage}</p>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default WidgetShell;
